import { defineMessages } from 'react-intl-next';

export const i18n: {
    addSection: {
        defaultMessage: string;
        description: string;
        id: string;
    }; contentHeader: {
        defaultMessage: string;
        description: string;
        id: string;
    }; contentSubHeader: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lozengeTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    }; placeHolderTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	addSection: {
		id: 'company-hub-section-cta.plus-button.add-section',
		defaultMessage: 'Add section',
		description: 'Label for the add section button',
	},
	contentHeader: {
		id: 'company-hub-section-cta.section-node.content.header',
		defaultMessage: 'Give your section a title',
		description: "Header of section extension's initial content",
	},
	contentSubHeader: {
		id: 'company-hub-section-cta.section-node.content.sub-header',
		defaultMessage: 'Organize elements into sections with customizable backgrounds.',
		description: "Sub-header of section extension's initial content",
	},
	lozengeTitle: {
		id: 'company-hub-section-cta.section-node.lozenge-title',
		defaultMessage: 'Section',
		description: 'Title of section extension to be displayed in lozenge',
	},
	placeHolderTitle: {
		id: 'company-hub-section-cta.section-node.content.placeholder-title',
		defaultMessage: 'Placeholder',
		description:
			'Title of hub element placeholder extension to be displayed the macro is presented in the editor.',
	},
});
